import React from 'react';

type Props = {
  onClick?: (e: any) => void;
  btnClass?: string;
  icon?: string;
  faIcon?: string;
  disabled?: boolean;
  // type?:string
  tag?: string;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

const SlickButton = (props: Props) => {
  const { onClick, btnClass, faIcon, disabled, icon, type, tag, ...rest } = props;
  const clickEvent = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!onClick) return;
    onClick(e);
  };

  let btn = btnClass ? `btn-slick ${btnClass}` : 'btn-slick';

  let ico = (() => {
    if (icon) return `feather icon-${icon}`;
    else if (faIcon) return `fa ${faIcon}`;
    else return '';
  })();

  return (
    <button
       disabled={disabled}
      //added button as def to prevent auto submitting in form
      // type={
      //   type ? type : tag === 'Reset' ? 'reset' : 'button'
      // }
      type={type || 'button'}
      className={btn}
      onClick={(e) => clickEvent(e)}
      {...rest}
    >
      <i className={ico}></i> {tag}
    </button>
  );
};

export default React.memo(SlickButton);
